import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/flag-ua.svg")